import React from 'react';
import { NodeFailureDetails, IssueType } from 'src/features/types/coraTypes';

interface CORANodeFailuresProps {
    nodeFailures: { [nodeId: string]: NodeFailureDetails };
}

const CORANodeFailures: React.FC<CORANodeFailuresProps> = ({ nodeFailures }) => {
    const failureEntries = Object.entries(nodeFailures);

    if (failureEntries.length === 0) {
        return null;
    }

    return (
        <div style={{ marginBottom: '1rem' }}>
            {failureEntries.map(([nodeId, failure]) => (
                <div key={nodeId} style={{ marginBottom: '0.5rem', color: '#d32f2f' }}>
                    <strong>{nodeId}</strong> failed to retrieve CPT Risk Data.
                    <br />
                    Error: <strong>{failure.issueType}</strong>
                </div>
            ))}
        </div>
    );
};

export default CORANodeFailures;
